import { contactUsFormInit } from './page-contact-hero/page-contact-hero';
import { initContactBanner } from './page-contact-banner/page-contact-banner';

document.addEventListener('DOMContentLoaded', () => {
  initContactBanner();
  contactUsFormInit();
});
